import ApiResourceManager from '../ApiResourceManager';

/**
 * Shop's Website Studio v2 project of the selected franchise (SH1), next to v1's /website-studio:
 * GET → {uuid, name, websites_count, domain} or 404 without one, POST → {uuid, name}, DELETE → 204.
 */
export default class WebsiteStudioV2Manager extends ApiResourceManager {
  create = async () =>
    this.request({
      method: 'POST',
      url: '/website-studio-v2',
    });

  get = async () =>
    this.request({
      method: 'GET',
      url: '/website-studio-v2',
    });

  delete = async () =>
    this.request({
      method: 'DELETE',
      url: '/website-studio-v2',
    });
}
